var tosConfirmationModalFunc = (function () {
  return {
    init: init,
  };

  var csrfToken, curLinkVal;

  function init() {
    if (window.hasOwnProperty('tosConfirmationOptions') && tosConfirmationOptions.enable) {
      uiBindings();
    }

    if (bsLib.getParameterByName('show-tnc') === 'true' && wpUserLoggedIn) {
      curLinkVal = 'OnPageLoad';
      showModal(curLinkVal);

      //Load Web Tracker
      loadWebTrackerEvents.push({
        eventName: 'beb_tnc_modal_view',
        eventProperty: {
          source: curLinkVal,
        }
      });
    }
  }

  function uiBindings() {
    // Select all anchor tags
    var anchors = document.querySelectorAll('a');

    // Loop through each anchor tag and add an event listener
    for (var i = 0; i < anchors.length; i++) {
      anchors[i].addEventListener('click', function (event) {
        var that = this,
          curLink = that.href;

        curLinkVal = that.text.trim();

        // Check if the href contains '/users/sign_up' || '/users/sign_in'
        if (curLink.indexOf('/users/sign_up') !== -1 || curLink.indexOf('/users/sign_in') !== -1) {
          event.preventDefault(); // Prevent default navigation if needed

          //signed in
          if (wpUserLoggedIn) {
            //check API
            bsLib.ajax(
              'GET',
              bsLib.railsHost() + '/user/show-tos-pp-notification',
              {},
              true,
              {},
              // Success message.
              function (data) {
                if (data.readyState === 4) {
                  var dataRequest = bsLib.JSONParse(data.response);

                  if (dataRequest.tos_and_pp_notification) {
                    //show modal
                    showModal(curLinkVal);
                  } else {
                    window.location.href = tosConfirmationOptions.redirect_url;
                  }
                }
              },
              // Custom Error message.
              function () {
                return Messages.salesAndSupportPage.somethingWrong;
              }
            );
          } else {
            //sign out
            window.location.href = tosConfirmationOptions.redirect_url;
          }
        }
      });
    }
  }

  function showModal(curLinkVal) {
    //csrfToken
    if (typeof csrf_token !== 'undefined') {
      csrfToken = csrf_token;
    } else if (!csrfToken) {
      setCSRFToken();
    }

    var tosModal = new tingle.modal({
      arialabelledby: 'tosConfirmationModalTitle',
      ariadescribedby: 'tosConfirmationModalDesc',
      closeIconLight: true,
      focusAfterClosed: this,
      cssClass: ['tos-modal-box'],
      onClose: function () {
        if (window.hasOwnProperty("WebEventTracker")) {
          WebEventTracker.logEvent(EDS.webEvents, 'beb_tnc_modal_cancelled', {
            source: curLinkVal,
          });
        }

        tosModal.destroy();
      },
    });
    var modalContainer = document.querySelector('.tos-modal');
    tosModal.setContent(modalContainer.innerHTML);
    tosModal.open();

    //Web Event
    if (window.hasOwnProperty("WebEventTracker")) {
      WebEventTracker.logEvent(EDS.webEvents, 'beb_tnc_modal_view', {
        source: curLinkVal,
      });
    }

    //Proceed Btn action
    var tosProceedBtn = document.querySelector('.tos-modal__proceed_btn');

    if (tosProceedBtn) {
      tosProceedBtn.addEventListener('click', function (evt) {
        evt.preventDefault();

        if (window.hasOwnProperty("WebEventTracker")) {
          WebEventTracker.logEvent(EDS.webEvents, 'beb_tnc_modal_accept', {
            source: curLinkVal,
          });
        }

        bsLib.ajax(
          'POST',
          bsLib.railsHost() + '/user/accept-tos-pp',
          JSON.stringify({}),
          true, //async
          {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          }, //request header
          function () {
            window.location.href = tosConfirmationOptions.redirect_url;
          }, //success
          function () {}, //error object
          true
        );
      });
    }
  }

  function setCSRFToken() {
    bsLib.ajax(
      'GET',
      bsLib.railsHost() + '/user/token.json',
      {},
      true,
      {},
      // Success message for user token.
      function (data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response);

          csrfToken = dataRequest.csrf_token;
          csrf_token = csrfToken;
        }
      },
      // Custom Error message for user token.
      function () {
        return Messages.salesAndSupportPage.invalidUserToken;
      }
    );
  }
})();

tosConfirmationModalFunc.init();
